<template>
  <div style="position: absolute; right: 5px; top: 5px; z-index: 2">
    <v-btn
      icon="mdi-close-circle-outline"
      class="button"
      @click="isCloseModalOpen = true"
      density="compact"
      style="border-radius: 100% !important"
    >
    </v-btn>
  </div>
  <v-dialog v-model="isLinkModalOpen" width="99%" max-width="800px">
    <v-card class="bg">
      <v-col align="center" style="color: white" class="pb-0">
        <h2>Gestion des liens</h2>
      </v-col>
      <v-col>
        <v-card>
          <v-text-field
            v-model="linkData['url']"
            label="Url de destination"
            hide-details
          ></v-text-field>
        </v-card>
        <v-card class="mt-3">
          <v-select
            v-model="linkData['rel']"
            label="REL"
            :no-data-text="'rrr'"
            hide-details
            :items="['nofollow', 'dofollow', 'sponsored', 'ugc']"
          ></v-select>
        </v-card>
      </v-col>
      <v-col align="center" class="pt-0">
        <v-btn
          v-if="linkData['url'] != undefined"
          class="buttonReverse"
          @click="setLink(linkData)"
        >
          Ajouter mon lien
        </v-btn>
        <v-btn v-else disabled class="buttonReverse">
          l'URL de destination est obligatoire
        </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showShareDesc" width="99%" max-width="800px">
    <v-card>
      <v-col class="bg" align="center">
        <v-btn
          @click="showShareDesc = false"
          icon="mdi-close"
          style="
            position: absolute;
            right: 10px;
            top: 8px;
            border: solid 2px white !important;
          "
          density="compact"
          class="button"
        >
        </v-btn>
        <h2 style="color: white">Texte promotionnel</h2>
      </v-col>
      <v-divider></v-divider>
      <v-col class="pt-0">
        <div
          class="pa-2"
          v-html="
            localEditionDataForm['description_to_share'].value.replaceAll(
              /href=&quot;[^&quot;]*&quot;/g,
              ''
            )
          "
        ></div>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="isCloseModalOpen" width="auto">
    <v-card>
      <v-col>
        <v-row justify="center" align="center">
          <v-col
            cols="12"
            align="center"
            style="font-weight: bold; font-size: 21px"
            class="pb-0"
          >
            Quitter l'éditeur ? <br />
            <span style="color: red; font-size: 15px"
              >Les modifications non enregistrées seront perdu !</span
            >
          </v-col>
          <v-col align="right">
            <v-btn
              class="button_armo"
              style="background-color: red; color: white"
              variant="flat"
              @click="isCloseModalOpen = false"
            >
              Non
            </v-btn>
          </v-col>
          <v-col align="left">
            <v-btn
              class="button_armo"
              style="background-color: green; color: white"
              variant="flat"
              @click="closeModal()"
            >
              Oui
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="isReportOpen" fullscreen persistent>
    <v-btn
      icon
      @click="isReportOpen = false"
      class="button"
      style="
        position: absolute;
        right: 10px;
        top: 2px;
        z-index: 20;
        border-radius: 100% !important;
      "
      density="compact"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <lighthouse :__LIGHTHOUSE_JSON__="localLighthouseHtml"></lighthouse>
  </v-dialog>
  <v-dialog v-model="isImageModalOpen" width="90%" max-width="750" persistent>
    <v-card class="bg">
      <v-btn
        @click="closeImageModal"
        style="position: absolute; right: 5px; top: 5px; z-index: 4"
        icon
        density="compact"
      >
        <v-icon color="red"> mdi-close </v-icon>
      </v-btn>
      <v-col
        align="center"
        style="font-weight: bold; font-size: 25px; color: white"
        class="pb-1"
      >
        Photo édition
      </v-col>
      <v-divider></v-divider>
      <v-col>
        <v-text-field
          variant="solo"
          label="Entrer un URL"
          hide-details
          v-model="newImageData.src"
        >
        </v-text-field>
      </v-col>
      <v-col class="py-0">
        <h3 style="color: white" align="center">OU</h3>
      </v-col>
      <v-col>
        <v-card class="py-1 px-3">
          <v-file-input
            hide-details
            prepend-icon="mdi-camera"
            accept="image/*"
            v-model="newImageData.file"
            label="Charger une image"
          ></v-file-input>
        </v-card>
      </v-col>
      <v-col>
        <v-textarea
          variant="solo"
          label="ALT"
          auto-grow
          rows="1"
          hide-details
          v-model="newImageData.alt"
        >
        </v-textarea>
      </v-col>
      <!-- <v-col>
        <v-row>
          <v-col cols="12">
            <v-text-field
              variant="solo"
              label="Longeur (width) en pixel"
              type="number"
              hide-details
              v-model="newImageData.maxWidth"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col> -->
      <!-- <v-col align="center">
        <v-card class="px-2">
          <div style="font-weight: bold; font-size: 20px" class="py-2">Positionement</div>
          <v-radio-group
            inline
            style="width: 100%"
            v-model="newImageData.pos"
            variant="solo"
            align="center"
          >
            <v-radio
              density="compact"
              style="width: 33.3%"
              label="A Gauche"
              value="float:left;"
            ></v-radio>
            <v-radio
              density="compact"
              style="width: 33.3%"
              label="Au millieu"
              value="display:block;margin:auto;"
            ></v-radio>
            <v-radio
              density="compact"
              style="width: 33.3%"
              label="A droite"
              value="float:right;"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </v-col> -->
      <v-col align="center">
        <div
          v-if="
            (newImageData.src == undefined || newImageData.src.length == 0) &&
            newImageData.file == undefined
          "
        >
          <v-chip style="background-color: red; color: white; font-weight: bold">
            L'URL et le positionnement sont obligatoires !
          </v-chip>
        </div>
        <v-btn
          class="button"
          style="border: solid 2px white !important"
          v-else
          @click="addImage"
          :disabled="
            (newImageData.src == undefined || newImageData.src.length == 0) &&
            newImageData.file == undefined
          "
        >
          Valider
        </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialogIsOpen['date']" width="auto" persistent>
    <v-col>
      <v-card>
        <v-col align="center" class="pb-1">
          <h3>Choisir une date et une horaire de publication</h3>
        </v-col>
        <v-divider class="mx-2 my-2"></v-divider>
        <v-col>
          <v-row justify="center" align="center">
            <v-col>
              <input
                type="datetime-local"
                v-model="localEditionDataForm.publication_datetime.value"
              />
              {{ localEditionDataForm.publication_datetime.value }}
            </v-col>
            <v-col align="center" cols="">
              <DatePicker
                v-model="localEditionDataForm.publication_date.value"
                inline
                auto-apply
                datetime
                :enable-time-picker="false"
                locale="fr"
              >
              </DatePicker>
              {{ localEditionDataForm.publication_date.value }}
            </v-col>
            <v-col align="center" cols="">
              <input
                class="inputTime"
                type="time"
                v-model="localEditionDataForm.publication_time.value"
              />
              {{ localEditionDataForm.publication_time.value }}
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-card class="pa-2" variant="tonal" align="center">
            {{ formateDate(localEditionDataForm.publication_date.value, "LL") }}
            à
            {{ localEditionDataForm.publication_time.value }}
          </v-card>
        </v-col>
        <v-col align="center">
          <v-btn
            @click="dialogIsOpen['date'] = false"
            :disabled="
              localEditionDataForm.publication_datetime.value == undefined
                ? true
                : localEditionDataForm.publication_datetime.value.length > 0
                ? false
                : true
            "
            >Valider</v-btn
          >
        </v-col>
      </v-card>
    </v-col>
  </v-dialog>
  <!-- <v-col style="" class="bg"
      v-if="localEditionDataForm && blogListe && localSelectedSite && blogListe[localSelectedSite.label] && typeof localEditionDataForm['post_compte_id'].value == 'object'"> -->
  <v-col
    style="position: relative"
    class="bg local-scrollbar"
    v-if="localEditionDataForm && localSelectedSite"
  >
    <!-- <v-col class="pt-0" style="color: white; font-weight: bold; font-size: 20px">
      Gestion d’article
    </v-col> -->
    <v-row style="background: var(--BG)">
      <v-col
        :style="{ 'min-height': isMobile ? '' : isPosted ? '100vh' : '92.5vh' }"
        style="position: relative"
        md="3"
        cols="12"
        class=""
        align="center"
      >
        <div :style="!isMobileXs ? 'position: sticky;top:13px' : ''">
          <v-card
            class=""
            style="border-right: solid 2px white; border-left: solid 2px white"
          >
            <div
              style="position: absolute; bottom: 10px; right: 5px"
              v-if="
                userInformation &&
                userInformation.settings &&
                userInformation.settings.show_share_data &&
                localEditionDataForm['description_to_share'] &&
                localEditionDataForm['description_to_share'].value &&
                localEditionDataForm['description_to_share'].value.length > 0
              "
            >
              <v-btn
                icon="mdi-share"
                @click="showShareDesc = true"
                style="z-index: 2; border: solid 2px white !important; font-size: 17px"
                size="35px"
                class="button"
              >
              </v-btn>
            </div>
            <v-img
              :style="{
                border:
                  localEditionDataForm.image_path.isValide == false
                    ? 'solid 2px red'
                    : 'solid 1px transparent',
              }"
              v-if="localEditionDataForm.image_path.value != undefined"
              @click="chooseImage"
              max-height="260"
              height="260"
              max-width="260"
              min-width="100%"
              :src="localEditionDataForm.image_path.value"
            />
            <div
              v-else
              @click="chooseImage"
              :style="{
                border:
                  localEditionDataForm.image_path.isValide == false
                    ? 'solid 2px red'
                    : '',
              }"
              style="
                background-color: white;
                max-height: 37vh;
                min-height: 32vh;
                border-radius: 5px;
                padding-top: 8vh;
                cursor: pointer;
              "
            >
              <v-icon icon="mdi-camera" color="#757575" size="90px"></v-icon>
              <h1 style="color: #757575">Séléctionner une image</h1>
            </div>
            <v-file-input
              ref="file_upload"
              accept="image/*"
              @update:modelValue="setNewPhoto"
              style="visibility: hidden; height: 0px"
            >
            </v-file-input>
          </v-card>
          <div style="" class="mb-2">
            <v-col
              class="px-0 pb-0"
              v-if="
                localEditionDataForm &&
                localEditionDataForm.metadata.value.title != undefined &&
                localSelectedSite != undefined
              "
            >
              <v-card
                class="card py-4"
                style="position: relative"
                align="left"
                variant="flat"
              >
                <div class="px-3">
                  <div style="position: relative">
                    <div style="position: absolute; right: 0px; z-index: 2">
                      <BasicHelpBox
                        style="position: relative"
                        msg="Balise HTML correspondant au titre de votre page web."
                      >
                      </BasicHelpBox>
                    </div>
                  </div>
                  <v-textarea
                    class="text-input-blue"
                    label="Meta title"
                    rows="1"
                    auto-grow
                    bg-color="white"
                    hide-details
                    v-model="localEditionDataForm.metadata.value.title"
                  >
                  </v-textarea>
                  <div
                    class="pt-1 px-4"
                    style="color: #4caf50; font-size: 9px"
                    v-if="
                      blogListe &&
                      localSelectedSite &&
                      localEditionDataForm &&
                      blogListe[localSelectedSite.label]
                    "
                  >
                    <div v-if="isPosted">
                      <a :href="getArticleUrl" target="_blank">{{ getArticleUrl }}</a>
                    </div>
                    <div v-else>
                      {{ getArticleUrl }}
                    </div>
                  </div>
                </div>
                <v-divider></v-divider>
                <div style="position: relative">
                  <v-textarea
                    label="Meta description"
                    rows="1"
                    auto-grow
                    class="mt-0 pt-0 px-3"
                    bg-color="white"
                    hide-details
                    v-model="localEditionDataForm.metadata.value.description"
                  >
                  </v-textarea>
                  <div style="position: absolute; right: 11px; top: 5px; z-index: 2">
                    <BasicHelpBox
                      style="position: relative"
                      msg="Balise HTML correspondant au titre de votre page web."
                    >
                    </BasicHelpBox>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col
              class="px-0 pb-0"
              v-if="localEditionDataForm && localEditionDataForm.author"
            >
              <v-card class="pa-0 card" variant="flat" style="border: solid 2px white">
                <v-text-field
                  class="pa-0"
                  label="Auteur"
                  bg-color="white"
                  hide-details
                  v-model="localEditionDataForm.author.value"
                >
                </v-text-field>
              </v-card>
            </v-col>
            <v-col
              class="px-0 pb-0"
              v-if="blogListe && siteInfoListe && siteInfoListe.length > 1"
            >
              <v-card v-if="!isPosted" class="mb-3 px-4 py-2 card" variant="flat">
                <v-select
                  :variant="!isPosted ? 'underlined' : 'text'"
                  v-model="localSelectedSite"
                  :items="siteInfoListe"
                  item-title="label"
                  label="Site sélectionné"
                  hide-details
                  return-object
                >
                  <template v-slot:selection="{ item }">
                    <div align="left">
                      {{ item.title }}
                    </div>
                  </template>
                </v-select>
              </v-card>
              <v-card v-else class="pa-2 mb-3 card" variant="flat" align="left">
                Site sélectionné :
                <span style="font-weight: bold">{{ localSelectedSite.label }}</span>
              </v-card>
              <div
                v-if="
                  blogListe &&
                  localSelectedSite &&
                  localSelectedSite.label &&
                  blogListe[localSelectedSite.label]
                "
              >
                <div v-if="!isPosted">
                  <v-card
                    v-if="
                      blogListe[localSelectedSite.label] &&
                      blogListe[localSelectedSite.label].length > 0
                    "
                    class="px-4 py-2 card"
                    variant="flat"
                  >
                    <v-select
                      :style="{
                        border:
                          localEditionDataForm.post_compte_id.isValide == false
                            ? 'solid 2px red'
                            : '',
                      }"
                      v-model="localEditionDataForm['post_compte_id'].value"
                      variant="underlined"
                      clearable
                      hide-details
                      :label="localEditionDataForm['post_compte_id'].label"
                      item-value="id"
                      :items="blogListe[localSelectedSite.label]"
                    >
                      <template v-slot:selection="{ item }">
                        <div align="left">
                          {{ item.title }}
                        </div>
                      </template>
                    </v-select>
                  </v-card>
                </div>
                <div v-else>
                  <v-card
                    v-if="
                      blogListe &&
                      blogListe.length > 0 &&
                      localSelectedSite &&
                      blogListe[localSelectedSite.label] &&
                      blogListe[localSelectedSite.label][0]
                    "
                    class="pa-2 card"
                    variant="flat"
                    align="left"
                  >
                    <div>
                      Blog de publication :
                      <span style="font-weight: bold">{{
                        blogListe[localSelectedSite.label].find(
                          (val) =>
                            val.id == localEditionDataForm["post_compte_id"].value.id
                        ).title
                      }}</span>
                    </div>
                  </v-card>
                </div>
              </div>
            </v-col>
            <v-col
              class="px-0 pb-0"
              v-if="getHtmlLinks && Object.values(getHtmlLinks).length > 0"
            >
              <v-card class="px-4 py-2 card" variant="flat">
                <div align="left" style="color: grey; font-size: 12px">
                  Liste des liens utilisé
                </div>
                <v-col class="px-3">
                  <v-row>
                    <v-col
                      v-for="(links, idx) in getHtmlLinks"
                      :key="idx"
                      align="left"
                      cols="auto"
                      class="py-0 px-0"
                    >
                      <v-tooltip activator="parent" location="start">
                        {{ links.url }}</v-tooltip
                      >
                      <a
                        :href="links.url"
                        style="font-size: 14px"
                        target="_blank"
                        class="pr-1"
                      >
                        {{ links.text }}</a
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-card>
            </v-col>
            <v-col
              class="px-0 pb-0"
              v-if="localEditionDataForm['tags'] && localEditionDataForm['tags'].value"
            >
              <v-card class="card" variant="flat">
                <div class="py-2 px-1">
                  <v-combobox
                    label="Balise (tags)"
                    variant="underlined"
                    closable-chips
                    multiple
                    chips
                    v-model="localSelectedTags"
                    hide-details
                    style="border: none; border-radius: 5px"
                    class="pa-2"
                    :items="localEditionDataForm['tags'].value.split(',')"
                  >
                  </v-combobox>
                </div>
              </v-card>
            </v-col>
          </div>
          <v-col
            align="left"
            class="px-0 pt-1 pb-0"
            cols="12"
            v-if="
              publishNow == false &&
              localSelectedSite &&
              localSelectedSite.compte_token &&
              localEditionDataForm.isPosted.value != 1
            "
          >
            <v-card
              class="px-1 pb-3 pt-3 card"
              style="text-transform: none; width: 100%"
              variant="flat"
              :style="{
                border:
                  localEditionDataForm.publication_date.isValide == false
                    ? 'solid 2px red'
                    : '',
                'background-color':
                  localEditionDataForm.isPosted.value != 2 ? '#7CB342' : '#EF9A9A',
              }"
            >
              <div
                v-if="localEditionDataForm.isPosted.value != 2"
                class="pl-3 mb-2"
                style="font-size: 12px; color: white"
              >
                Date de publication
              </div>
              <div class="px-2" v-if="localEditionDataForm.isPosted.value != 2">
                <v-card variant="flat">
                  <input
                    style="width: 100%; border: solid 1px lightgrey; border-radius: 5px"
                    class="pa-3"
                    type="datetime-local"
                    :min="minDateTime"
                    v-model="localEditionDataForm.publication_datetime.value"
                    :disabled="isPosted || localEditionDataForm.isPosted.value == 2"
                  />
                </v-card>
              </div>
              <div class="pa-2">
                <v-switch
                  style="font-weight: bold; color: black"
                  hide-details
                  v-model="localEditionDataForm.isPosted.value"
                  :true-value="0"
                  :false-value="2"
                  inset
                  :color="localEditionDataForm.isPosted.value == 0 ? 'white' : 'red'"
                  :label="
                    'Publication ' +
                    (localEditionDataForm.isPosted.value == 2 ? 'désactivée' : 'activée')
                  "
                />
              </div>
            </v-card>
          </v-col>
        </div>
      </v-col>
      <v-col
        md="9"
        cols="12"
        class="px-2 pb-2 mt-3"
        style="position: relative; background-color: white"
      >
        <v-card
          v-if="!isPosted"
          class="py-2 px-4"
          variant="flat"
          style="border: solid 1px lightgray; border-radius: 10px"
        >
          <v-text-field
            :style="{
              border: localEditionDataForm.title.isValide == false ? 'solid 2px red' : '',
            }"
            :label="localEditionDataForm['title'].label"
            hide-details
            v-model="localEditionDataForm['title'].value"
            variant="underlined"
          >
          </v-text-field>
        </v-card>
        <v-card v-else variant="text" align="left" class="py-3">
          Titre de l'article :
          <span style="font-weight: bold">{{ localEditionDataForm["title"].value }}</span>
        </v-card>
        <div
          style="background-color: white; position: relative; padding-bottom: 50px"
          class=""
          :style="{
            border:
              localEditionDataForm.description.isValide == false
                ? 'solid 2px red'
                : 'none',
          }"
        >
          <div v-if="isPosted">
            <h4 align="left" style="color: #f44336" class="pa-2">
              Cet article est publié est n'est plus modifiable avec Jauris.
            </h4>
            <v-textarea
              class="mt-2"
              bg-color="white"
              v-if="contentType.raw.includes(localEditionDataForm.platform.value)"
              v-model="content"
              auto-grow
              hide-details
            ></v-textarea>
            <div
              v-if="contentType.html.includes(localEditionDataForm.platform.value)"
              class=""
              align="left"
            >
              <editor-content style="" :editor="editor" />
            </div>
          </div>
          <div v-else>
            <div>
              <div
                class="container"
                :style="{ 'padding-bottom': isMobile ? '60px' : '0px' }"
              >
                <div
                  v-if="
                    editor &&
                    contentType.html.includes(localEditionDataForm.platform.value)
                  "
                  style="
                    position: sticky;
                    top: 0px;
                    z-index: 1;
                    padding-top: 8px;
                    background-color: white;
                  "
                  class="mt-4"
                >
                  <v-col
                    cols="12"
                    class=""
                    style="
                      border: solid 1px var(--C1);
                      border-bottom: none;
                      border-right: none;
                    "
                  >
                    <v-row>
                      <v-col
                        v-for="(item, i) in btnListe"
                        :key="i"
                        cols=""
                        class="pa-0"
                        style="
                          border-right: solid 1px var(--C1);
                          border-bottom: solid 1px var(--C1);
                        "
                      >
                        <BasicHelpBox
                          style="position: relative"
                          :icon="false"
                          location="bottom"
                          :msg="item.help"
                        >
                          <v-menu
                            v-if="item.isMenu"
                            transition="slide-y-transition"
                            variant="flat"
                          >
                            <template v-slot:activator="{ props }">
                              <v-btn
                                v-bind="props"
                                variant="flat"
                                append-icon="mdi-menu-down"
                                style="
                                  border-radius: 0px;
                                  background-color: white;
                                  color: var(--C1);
                                  width: 100%;
                                "
                              >
                                <v-icon :size="item.iconSize">{{ item.icon }} </v-icon>
                              </v-btn>
                            </template>
                            <v-btn
                              v-for="(btn, idx) in item.values"
                              :key="idx"
                              variant="flat"
                              style="border-radius: 0px"
                              @click="runFunction(item.function, btn.value)"
                              :color="btn.color"
                            >
                              <v-icon v-if="btn.icon" size="30"> {{ btn.icon }}</v-icon>
                              {{ btn.label }}</v-btn
                            >
                          </v-menu>
                          <v-btn
                            v-else
                            variant="flat"
                            style="
                              border-radius: 0px;
                              background-color: white;
                              color: var(--C1);
                              width: 100%;
                            "
                            @click="runFunction(item.function, item.value)"
                            :disabled="
                              item.canBeDisabled
                                ? !editor
                                    .can()
                                    .chain()
                                    .focus()
                                    [item.function.name]()
                                    .run()
                                : false
                            "
                          >
                            <v-icon :size="item.iconSize">{{ item.icon }} </v-icon>
                          </v-btn>
                        </BasicHelpBox>
                      </v-col>
                      <v-col
                        cols=""
                        class="pa-0"
                        style="
                          border-right: solid 1px var(--C1);
                          border-bottom: solid 1px var(--C1);
                        "
                      >
                        <BasicHelpBox
                          style="position: relative"
                          :icon="false"
                          location="bottom"
                          :msg="'Ajoute un lien hypertexte au texte sélectionné pour créer une redirection.'"
                        >
                          <v-btn
                            variant="flat"
                            style="
                              border-radius: 0px;
                              background-color: white;
                              color: var(--C1);
                              width: 100%;
                            "
                            @click="addLink"
                          >
                            <v-icon size="20">mdi-plus-thick</v-icon>
                            <v-icon size="35">mdi-link-box-variant-outline</v-icon>
                          </v-btn>
                        </BasicHelpBox>
                      </v-col>
                      <v-col
                        cols=""
                        class="pa-0"
                        style="
                          border-right: solid 1px var(--C1);
                          border-bottom: solid 1px var(--C1);
                        "
                      >
                        <BasicHelpBox
                          style="position: relative"
                          :icon="false"
                          location="bottom"
                          :msg="'Supprime le lien du texte sélectionné et rétablit le texte normal.'"
                        >
                          <v-btn
                            variant="flat"
                            style="
                              border-radius: 0px;
                              background-color: white;
                              color: var(--C1);
                              width: 100%;
                            "
                            @click="removeLink"
                          >
                            <v-icon size="20">mdi-minus-thick</v-icon>
                            <v-icon size="35">mdi-link-box-variant-outline</v-icon>
                          </v-btn>
                        </BasicHelpBox>
                      </v-col>
                      <v-col
                        cols=""
                        class="pa-0"
                        style="
                          border-right: solid 1px var(--C1);
                          border-bottom: solid 1px var(--C1);
                        "
                      >
                        <BasicHelpBox
                          style="position: relative"
                          :icon="false"
                          location="bottom"
                          :msg="'Insère une image dans le document à partir d\'une URL.'"
                        >
                          <v-btn
                            @click="isImageModalOpen = true"
                            variant="flat"
                            style="
                              border-radius: 0px;
                              background-color: white;
                              color: var(--C1);
                              width: 100%;
                            "
                          >
                            <v-icon :size="30"> mdi-image-plus </v-icon>
                          </v-btn>
                        </BasicHelpBox>
                      </v-col>
                      <v-col
                        cols=""
                        class="pa-0"
                        style="
                          border-bottom: solid 1px var(--C1);
                          border-right: solid 1px var(--C1);
                        "
                      >
                        <BasicHelpBox
                          style="position: relative"
                          :icon="false"
                          location="bottom"
                          :msg="'Visualise le contenu sous forme de code HTML.'"
                        >
                          <v-btn
                            @click="toggleHtml"
                            variant="flat"
                            style="
                              border-radius: 0px;
                              background-color: white;
                              color: var(--C1);
                              width: 100%;
                            "
                          >
                            <v-icon :size="30"> mdi-file-code-outline </v-icon>
                          </v-btn>
                        </BasicHelpBox>
                      </v-col>
                    </v-row>
                  </v-col>
                </div>
                <v-col class="py-3 pb-0 px-0" align="right">
                  <v-chip
                    class=""
                    style="background: var(--BG); color: white; font-weight: bold"
                  >
                    Nombre de mot(s) <v-icon>mdi-approximately-equal</v-icon
                    >{{ compterMots }}
                  </v-chip>
                  <v-chip
                    class="ml-2"
                    style="background: var(--BG); color: white; font-weight: bold"
                  >
                    Nombre de caractère(s) <v-icon>mdi-approximately-equal</v-icon
                    >{{ compterCaracteres }}
                  </v-chip>
                  <v-chip
                    v-if="localEditionDataForm.platform.value == 'Instagram'"
                    class="ml-2"
                    style="background: #ef5350; color: white; font-weight: bold"
                  >
                    Instagram max caractères
                    <v-icon class="mx-1" size="15">mdi-less-than-or-equal</v-icon> 2100
                  </v-chip>
                </v-col>
                <v-col class="px-0 pb-0 contentClass">
                  <v-card
                    v-if="contentType.html.includes(localEditionDataForm.platform.value)"
                    class=""
                    variant="flat"
                    :style="showHtml ? 'background-color:#263238;color:white' : ''"
                    style="border-radius: 0px"
                  >
                    <div v-if="showHtml">
                      <v-textarea
                        readonly
                        v-model="content"
                        auto-grow
                        rows="1"
                        hide-details
                      ></v-textarea>
                    </div>
                    <div v-else class="" align="left">
                      <editor-content style="" :editor="editor" />
                    </div>
                  </v-card>
                  <v-card
                    v-if="contentType.raw.includes(localEditionDataForm.platform.value)"
                  >
                    <v-textarea
                      variant="flat"
                      style="border: solid 1px var(--C1)"
                      class="mt-2"
                      bg-color="white"
                      v-model="content"
                      auto-grow
                      hide-details
                    ></v-textarea>
                  </v-card>
                </v-col>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
        <iframe v-if="pdfDataUrl" :src="pdfDataUrl" width="100%" height="500px"></iframe>
      </v-col>
      <div
        cols="12"
        v-if="!isPosted"
        style="
          height: 45px;
          position: fixed;
          bottom: 0px;
          right: 0px;
          left: 0px;
          z-index: 3;
        "
      >
        <div>
          <v-btn
            v-if="!showHtml"
            class="button"
            variant="flat"
            style="width: 300px"
            @click="formVerification()"
          >
            {{ validationLabel }}
          </v-btn>
          <v-btn
            v-else
            class="button"
            variant="flat"
            disabled
            style="width: 98%; max-width: 500px"
          >
            Sauvegarde indisponible en mode HTML
          </v-btn>
        </div>
        <v-card
          v-if="!isMobile"
          style="
            position: absolute;
            bottom: 5px;
            right: 5px;
            z-index: 4;
            border: solid 3px var(--C1);
          "
          variant="flat"
          class="pa-1"
        >
          <div style="font-weight: bold">Export</div>
          <v-btn class="button ma-1" @click="creatHtml" color="blue"
            ><v-icon size="30">mdi-file-code</v-icon></v-btn
          >
          <v-btn class="button ma-1" @click="downloadAsWord" color="blue">
            <v-icon size="30">mdi-file-word</v-icon></v-btn
          >
        </v-card>
      </div>
    </v-row>
  </v-col>
  <v-snackbar
    v-model="error.isShowing"
    :color="error.color == undefined ? 'red' : error.color"
  >
    <div style="font-weight: bold">
      {{ error.errorLabel }}
    </div>
  </v-snackbar>
  <!-- this.error.errorLabel += keyNotValid[i] + ' / '
        }
        this.error.isShowing = true -->
</template>

<script>
// import { VueEditor } from "vue3-editor";

import { ref, onMounted } from "vue";
import moment from "moment";
// import html2canvas from 'html2canvas'
import htmlDocx from "html-docx-js/dist/html-docx";

import { Color } from "@tiptap/extension-color";
import ListItem from "@tiptap/extension-list-item";
import StarterKit from "@tiptap/starter-kit";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
// import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import TextStyle from "@tiptap/extension-text-style";
import ImageResize from "tiptap-extension-resize-image";

import Table from "@tiptap/extension-table";

import { Editor, EditorContent } from "@tiptap/vue-3";
import BasicHelpBox from "../basic/basic-help-box.vue";

import {
  CustomTable,
  TableHeader,
  TableRow,
  TableCell,
} from "../editorExtension/CustomTable.js";

import CustomInlineStyle from "../editorExtension/CustomInlineStyle";
// import CustomImageResize from "../editorExtension/customImg";
// import CustomDiv from "../editorExtension/CustomDiv";
import ParagraphWithId from "../editorExtension/ParagraphWithId";
import LinkWithStyle from "../editorExtension/link";
import hn from "../editorExtension/hn";

import { CustomBulletList, CustomListItem } from "../editorExtension/CustomListExtension"; // Assurez-vous que le chemin est correct

import lighthouse from "../lighthouse/lighthouse-report.vue";
import engine from "@/core/index";

import { v4 as uuidv4 } from "uuid";

export default {
  props: {
    windowSize: {},
    getOperatingSystem: {},
    lighthouseHtml: {},
    userInformation: {},
    localDataForm: { required: true },
    groupInformation: { required: true },
    validationFunction: { type: Function },
    validationLabel: {},
    blogListe: { required: true },
    isPosted: {},
    setIsLoading: { type: Function },
    closeModal: { type: Function },
    selectedSite: { required: true },
    siteInfoListe: {},
    selectedTags: {},
  },

  setup(props) {
    const isEventListenerAdded = ref(false);
    const isResizing = ref(false);
    const srcImageResize = ref(undefined);

    const error = ref({ isShowing: false, errorLabel: "" });
    const localSelectedSite = ref(undefined);
    const localEditionDataForm = ref(undefined);
    const contentType = ref({
      html: ["article_seo"],
      raw: ["Instagram", "post-instagram"],
    });

    const isLoading = ref(false);
    const publishNow = ref(false);
    const maxImageWidth = ref(undefined);
    const contentStyleData = ref(undefined);
    const dialogIsOpen = ref({});
    const localSelectedTags = ref({});

    const newImageData = ref({});
    const isImageModalOpen = ref(false);
    const showHtml = ref(false);
    const content = ref("");
    const editor = ref(null);
    const isLinkModalOpen = ref(false);
    const btnListe = ref([
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleBold",
        },
        icon: "mdi-format-bold",
        iconSize: "30",
        help: "Applique un format en gras au texte sélectionné pour le mettre en avant.",
      },
      {
        isMenu: true,
        function: {
          type: "complex",
          name: "toggleHeading",
        },
        icon: "mdi-format-header-pound",
        iconSize: "30",
        help:
          "Applique un titre (HN) au texte sélectionné pour structurer le document et améliorer la lisibilité.",
        values: [
          { value: { level: 1 }, label: "H1" },
          { value: { level: 2 }, label: "H2" },
          { value: { level: 3 }, label: "H3" },
          { value: { level: 4 }, label: "H4" },
        ],
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleItalic",
        },
        icon: "mdi-format-italic",
        iconSize: "30",
        help:
          "Ajoute une mise en forme en italique pour souligner une idée ou un mot-clé.",
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleBulletList",
        },
        icon: "mdi-format-list-bulleted",
        iconSize: "30",
        help:
          "Transforme le texte sélectionné en élément d’une liste à puces pour en faciliter la lecture.",
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleStrike",
        },
        icon: "mdi-format-strikethrough",
        iconSize: "30",
        help:
          "Ajoute une ligne au travers du texte pour indiquer une modification ou une suppression.",
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleOrderedList",
        },
        icon: "mdi-order-numeric-ascending",
        iconSize: "30",
        help:
          "Ajoute une numérotation au texte sélectionné pour structurer les informations de manière ordonnée.",
      },
      {
        isMenu: true,
        function: {
          type: "complex",
          name: "setColor",
        },
        icon: "mdi-palette",
        iconSize: "30",
        help: "Modifie la couleur du texte sélectionné pour le personnaliser.",
        values: [
          { value: "black", color: "black" },
          { value: "white", color: "white" },
          { value: "red", color: "red" },
          { value: "purple", color: "purple" },
        ],
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "toggleUnderline",
        },
        icon: "mdi-format-underline",
        iconSize: "30",
        help: "Souligne le texte sélectionné pour lui donner plus d’importance.",
      },
      {
        isMenu: true,
        function: {
          type: "complex",
          name: "setTextAlign",
        },
        icon: "mdi-format-align-left",
        iconSize: "30",
        help: "Aligne le texte sélectionné sur le bord sélectionné.",
        values: [
          { value: "left", icon: "mdi-format-align-left" },
          { value: "center", icon: "mdi-format-align-center" },
          { value: "right", icon: "mdi-format-align-right" },
          { value: "justify", icon: "mdi-format-align-justify" },
        ],
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "undo",
        },
        icon: "mdi-undo",
        iconSize: "30",
        canBeDisabled: true,
        help: "Annule la dernière action pour revenir à l’état précédent.",
      },
      {
        isMenu: false,
        function: {
          type: "complex",
          name: "redo",
        },
        icon: "mdi-redo",
        iconSize: "30",
        canBeDisabled: true,
        help: "Rétablit la dernière modification pour revenir à l’état précédent.",
      },
    ]);

    const setHtmlEnvInContent = function () {
      content.value = `
      <html>
        <head>
          <meta charset='UTF-8'>
        </head>
        <body>
          <style>
            ${contentStyleData.value ? contentStyleData.value : ""}
          </style>
          <div class='contentClass'>
            ${content.value}
          </div>
        </body>
      </html>`;

      // .contentClass img {
      //         border: solid 10px red !important;
      //         float:none;
      //       }
    };

    onMounted(() => {
      localEditionDataForm.value = JSON.parse(JSON.stringify(props.localDataForm));

      localSelectedSite.value = JSON.parse(JSON.stringify(props.selectedSite));
      localSelectedTags.value = JSON.parse(JSON.stringify(props.selectedTags));

      content.value = localEditionDataForm.value.description.value;
      // content.value = '<table style="width: 100%; border-collapse: collapse; margin-top: 20px;"> <thead style="background-color: #f2f2f2;"> <tr> <th style="border: 1px solid #ddd; padding: 8px;">Formation</th> <th style="border: 1px solid #ddd; padding: 8px;">Prix (en €)</th> <th style="border: 1px solid #ddd; padding: 8px;">Détails du contenu</th> </tr> </thead> <tbody> <tr> <td style="border: 1px solid #ddd; padding: 8px;">ABC Immobilier</td> <td style="border: 1px solid #ddd; padding: 8px;">900</td> <td style="border: 1px solid #ddd; padding: 8px;">Bases de la transaction immobilière. Webinaires inclus.</td> </tr> </tbody> </table> `,'
      setHtmlEnvInContent();

      if (
        localEditionDataForm.value.metadata.value &&
        localEditionDataForm.value.metadata.value.length > 0
      )
        localEditionDataForm.value.metadata.value = JSON.parse(
          localEditionDataForm.value.metadata.value
        );
      else localEditionDataForm.value.metadata.value = {};

      if (
        localEditionDataForm.value.links_redirect.value &&
        localEditionDataForm.value.links_redirect.value.length > 0
      )
        localEditionDataForm.value.links_redirect.value = JSON.parse(
          localEditionDataForm.value.links_redirect.value
        );
      else localEditionDataForm.value.links_redirect.value = {};

      if (props.blogListe && props.blogListe[localSelectedSite.value.label]) {
        localEditionDataForm.value["post_compte_id"].value = props.blogListe[
          localSelectedSite.value.label
        ].find((val) => val.id == localEditionDataForm.value["post_compte_id"].value);
      }

      editor.value = new Editor({
        extensions: [
          // CustomImageResize,
          ImageResize,
          Link.configure({
            openOnClick: true, // Garde le lien cliquable
            HTMLAttributes: {
              rel: "", // Bonnes pratiques de sécurité pour les liens
              target: "", // Ouvre le lien dans un nouvel onglet
            },
          }),
          Table,
          TableRow,
          TableCell,
          TableHeader,
          Color.configure({ types: [TextStyle.name, ListItem.name] }),

          // TextStyle,
          TextStyle.configure({ types: [ListItem.name] }),
          StarterKit,
          Underline,
          TextAlign.configure({
            types: ["heading", "paragraph"],
            defaultAlignment: "left", // Alignement par défaut
          }),
          ParagraphWithId,
          LinkWithStyle,
          CustomBulletList,
          CustomListItem,
          hn,
          CustomInlineStyle,
          CustomTable,
          // Link,
          // Image,
          // CustomImage,
          // // CustomDiv,
        ],
        onUpdate({ editor }) {
          if (isEventListenerAdded.value == false) {
            editor.view.dom.addEventListener("click", (event) => {
              const target = event.target;

              if (target && target.tagName === "IMG") {
                srcImageResize.value = target.src;
                changeImageWidth(editor);
              }
            });

            editor.view.dom.addEventListener("mousedown", (event) => {
              const target = event.target;

              if (target && target.tagName === "IMG") {
                isResizing.value = true;
              }
            });

            editor.view.dom.addEventListener("mouseup", () => {
              isResizing.value = false;
              onResizeEnd(editor);
            });

            isEventListenerAdded.value = true;
          }

          content.value = editor.getHTML();
        },
        editable: !props.isPosted,
      });
      editor.value.commands.setContent(content.value);

      // listenImageClick();
    });

    const onResizeEnd = function (editor) {
      const imageElement = editor.view.dom.querySelector(
        `img[src="${srcImageResize.value}"]`
      );
      if (srcImageResize.value && imageElement) {
        const newWidth = imageElement.style.width;

        if (newWidth) {
          imageElement.style.maxWidth = newWidth;
          imageElement.style.width = "100%";
        }
      }
      srcImageResize.value = undefined;
    };

    const changeImageWidth = function (editor) {
      const imageElement = editor.view.dom.querySelector(
        `img[src="${srcImageResize.value}"]`
      );

      if (srcImageResize.value && imageElement) {
        const newWidth = imageElement.style["max-width"];

        if (newWidth) {
          imageElement.style.maxWidth = "100vw";
          imageElement.style.width = newWidth;
        }
      }
    };

    const creatHtml = function () {
      var texte = content.value;
      var blob = new Blob([texte], { type: "text/plain;charset=utf-8" });
      var url = URL.createObjectURL(blob);

      var a = document.createElement("a");
      a.href = url;
      a.download = "article.html"; // Nom du fichier à télécharger
      document.body.appendChild(a);
      a.click();
    };

    const getBase64Image = function (file, callback) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        callback(reader.result);
      };
    };

    const setNewPhoto = function (file) {
      if (file && file[0] && file[0].size < 500000) {
        getBase64Image(file[0], function (dateUrl) {
          localEditionDataForm.value.image_path.value = dateUrl;
        });
      } else {
        error.value = {
          isShowing: true,
          errorLabel: "Taille de l'image supérieur à 500Ko!",
        };
      }
    };

    const formVerification = function () {
      props.setIsLoading(true);
      let keyNotValid = [];
      console.log("localEditionDataForm.value", localEditionDataForm.value);
      
      for (const obj of Object.values(localEditionDataForm.value)) {
        if (obj.isRequired == true && (obj.value == undefined || obj.value.length == 0)) {
          obj.isValide = false;
          keyNotValid.push(obj.label);
        } else {
          obj.isValide = true;
        }
      }
      if (keyNotValid.length == 0) {
        savePip();
        if (props.userInformation.klaviyo && props.userInformation.klaviyo.length > 0) {
          engine.set_klaviyo_event(
            props.userInformation.klaviyo,
            "Edition de l'article : " +
              props.localDataForm.title.value +
              " / ID : " +
              props.localDataForm.publication_id.value
          );
        }
      } else {
        props.setIsLoading(false);
        this.error.errorLabel = "Une erreur est survenue avec l'édition de votre :  ";
        for (let i = 0; i < keyNotValid.length; i++) {
          this.error.errorLabel += keyNotValid[i];
          if (keyNotValid.length > i + 1) this.error.errorLabel += " / ";
        }
        this.error.isShowing = true;
      }
    };

    const saveBase64ImgToServer = async function (bas64Data, callback) {
      try {
        let path =
          "/medias/articles/" +
          props.groupInformation.id +
          "/" +
          localEditionDataForm.value.publication_id.value;

        let idImg = uuidv4() + ".webp";

        await engine.save_base64_file_in_local(bas64Data, "build" + path + "/", idImg);

        callback("https://" + process.env.VUE_APP_USE_URL + "/" + path + "/" + idImg);
      } catch (error) {
        console.error("Erreur lors de la sauvegarde de l'image :", error);
        callback(null); // ou une autre gestion d’erreur
      }
    };

    const savePip = function () {
      localEditionDataForm.value.tags.value = localSelectedTags.value.join(",");
      // localEditionDataForm.value.platform.value = 'article_seo'
      localEditionDataForm.value.metadata.value = JSON.stringify(
        localEditionDataForm.value.metadata.value
      );
      localEditionDataForm.value.description.value = content.value;

      if (localEditionDataForm.value.image_path.value.includes("base64")) {
        let path =
          "/medias/articles/" +
          props.groupInformation.id +
          "/" +
          localEditionDataForm.value.publication_id.value;

        let idImg = uuidv4() + ".webp";
        engine.save_url_file_in_local(
          localEditionDataForm.value.image_path.value,
          "build/" + path,
          "build/" + path + "/" + idImg,
          function () {
            console.log("save récu");            
            localEditionDataForm.value.image_path.value =
              "https://" + process.env.VUE_APP_USE_URL + "/" + path + "/" + idImg;
            props.validationFunction(localEditionDataForm.value);
          }
        );
      } else {
        props.validationFunction(localEditionDataForm.value);
      }
    };

    const convertImageToWebP = async (imageSrc) => {
      return new Promise((resolve, reject) => {
        let img = new window.Image();
        img.src = imageSrc;
        img.crossOrigin = "Anonymous";
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);

          resolve(canvas.toDataURL("image/webp", 0.8));
        };
        img.onerror = (error) => reject(error);
      });
    };

    const waitForImageToLoad = function (src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          resolve();
        };
        img.onerror = (err) => {
          reject(err);
        };
        img.src = src;
      });
    };

    const addImage = async function () {
      if (newImageData.value.id == undefined) {
        if (newImageData.value.file) {
          const reader = new FileReader();
          reader.readAsDataURL(newImageData.value.file[0]);
          await new Promise((resolve) => (reader.onloadend = resolve));

          let res = reader.result;
          let res2 = await convertImageToWebP(res);

          error.value = {
            isShowing: true,
            color: "green",
            errorLabel: "Votre image va apparaître d'ici quelques secondes.",
          };
          newImageData.value.file = undefined;
          await saveBase64ImgToServer(res2, async function (src) {
            newImageData.value.src = src;
            // let img = `<img src='${newImageData.value.src}' alt='${newImageData.value.alt}' style='width:100%; max-width:500px;max-height:100%;height:auto;' />`;
            let img = `<img src='${newImageData.value.src}' alt='${newImageData.value.alt}' style='width:100%; max-width:500px;height:auto;' />`;
            editor.value.chain().focus().insertContent(img).run();
            await waitForImageToLoad(newImageData.value.src);
          });
        }
      }

      isImageModalOpen.value = false;
      newImageData.value = {};
    };

    const closeImageModal = function () {
      isImageModalOpen.value = false;
      newImageData.value = {};
    };

    // const findImage = function (id, callback) {
    //   let images = editor.value.view.dom.querySelectorAll("img");
    //   for (let image of images) {
    //     if (image.id == id) {
    //       callback(image);
    //       break;
    //     }
    //   }
    // };

    const toggleHtml = function () {
      showHtml.value = !showHtml.value;
      if (showHtml.value) {
        content.value = editor.value.getHTML();
      } else {
        editor.value.commands.setContent(content.value);
      }
    };

    const setLink = function (linkData) {
      editor.value
        .chain()
        .focus()
        .extendMarkRange("link")
        .setLink({ href: linkData.url, rel: linkData.rel })
        .run();
      editor.value.on("update", () => {});
      isLinkModalOpen.value = false;
    };

    const removeLink = function () {
      editor.value.chain().focus().unsetLink().run();
    };

    const runFunction = function (functionData, param) {
      if (functionData.type == "basic") {
        [functionData.name](param);
      } else if (functionData.type == "complex") {
        if (param) {
          editor.value.chain().focus()[functionData.name](param).run();
        } else editor.value.chain().focus()[functionData.name]().run();
      }
    };

    return {
      isLoading,
      localEditionDataForm,
      setNewPhoto,
      dialogIsOpen,
      publishNow,
      formVerification,
      error,
      localSelectedSite,
      localSelectedTags,
      creatHtml,
      contentType,
      content,
      editor,
      btnListe,
      showHtml,
      runFunction,
      addImage,
      closeImageModal,
      toggleHtml,
      // listenImageClick,
      isImageModalOpen,
      newImageData,
      maxImageWidth,
      setHtmlEnvInContent,
      contentStyleData,
      setLink,
      removeLink,
      isLinkModalOpen,
    };
  },
  data() {
    return {
      linkData: {},
      showShareDesc: false,
      isCloseModalOpen: false,
      isReportOpen: false,
      localLighthouseHtml: undefined,
      pdfDataUrl: "",
      isShowHtmlOpen: false,
    };
  },
  watch: {
    maxImageWidth() {
      // this.updateContentStyle();
      this.setHtmlEnvInContent();
    },
    blogListe(val) {
      if (val && val[this.localSelectedSite.label]) {
        this.localEditionDataForm["post_compte_id"].value = val[
          this.localSelectedSite.label
        ].find((val) => val.id == this.localEditionDataForm["post_compte_id"].value);
      }
    },
    showHtml(val) {
      // this.listenImageClick();
      if (val == false) {
        this.setHtmlEnvInContent();
      }
    },
    content(newHtml) {
      if (this.showHtml && this.editor) {
        this.editor.commands.setContent(newHtml);
      }
      // this.listenImageClick();
    },
  },
  mounted() {
    // $(this.$refs.summernote).summernote();
    moment.locale("fr");
    // this.updateContentStyle();
  },
  computed: {
    minDateTime() {
      const now = new Date();
      now.setSeconds(0, 0); // Supprime les secondes/millisecondes
      return now.toISOString().slice(0, 16); // Format "YYYY-MM-DDTHH:MM"
    },
    getArticleUrl() {
      if (
        this.localEditionDataForm["post_compte_id"] &&
        this.localEditionDataForm["post_compte_id"].value &&
        this.localEditionDataForm["post_compte_id"].value.id
      ) {
        let url =
          this.selectedSite.url +
          "/blogs/" +
          this.blogListe[this.localSelectedSite.label].find(
            (val) => val.id == this.localEditionDataForm["post_compte_id"].value.id
          ).handle +
          "/" +
          this.formatStringToUrl(this.localEditionDataForm.title.value.toLowerCase());

        return url;
      }
      return "";
    },
    compterMots() {
      let element = document.createElement("div");
      element.innerHTML = this.content;

      let texteBrut = element.textContent || element.innerText || "";

      let chaine = texteBrut.trim();

      chaine = chaine.replace(/[-']/g, " ");
      chaine = chaine.replace(/\s+/g, " ");

      if (chaine === "") {
        return 0;
      }

      let mots = chaine.split(/\s+/);
      return mots.length;
    },
    compterCaracteres() {
      let element = document.createElement("div");
      element.innerHTML = this.content;

      let texteBrut = element.textContent || element.innerText || "";

      let chaine = texteBrut.trim();
      let chaineSansEspacesNiRetours = chaine.replace(/[\s]/g, "");

      return chaineSansEspacesNiRetours.length;
    },
    isMobileXs() {
      return this.$vuetify.display.xs;
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
    getHtmlLinks() {
      if (this.localEditionDataForm && this.content) {
        return Array.from(
          new DOMParser().parseFromString(this.content, "text/html").querySelectorAll("a")
        )
          .filter((val) => !val.href.includes("#"))
          .map((link) => ({
            url: link.href,
            text: link.innerHTML,
          }));
      } else return undefined;
    },
  },
  methods: {
    addLink() {
      this.linkData = { rel: "nofollow" };
      this.isLinkModalOpen = true;
    },
    formatStringToUrl(string) {
      // Enlever les accents
      let accents = {
        á: "a",
        à: "a",
        â: "a",
        ä: "a",
        ã: "a",
        å: "a",
        ç: "c",
        é: "e",
        è: "e",
        ê: "e",
        ë: "e",
        í: "i",
        ì: "i",
        î: "i",
        ï: "i",
        ñ: "n",
        ó: "o",
        ò: "o",
        ô: "o",
        ö: "o",
        õ: "o",
        ú: "u",
        ù: "u",
        û: "u",
        ü: "u",
        ý: "y",
        ÿ: "y",
      };

      let normalizedString = string
        .split("")
        .map((char) => accents[char] || char) // Remplace les caractères accentués
        .join("")
        .trim() // Enlève les espaces en début et fin
        .replace(/:/g, "") // Remplace les `:` par des tirets
        .replace(/\s+/g, "-") // Remplace les espaces par des tirets
        .replace(/[^\w-]/g, ""); // Enlève les caractères spéciaux

      return encodeURIComponent(normalizedString); // Encode la chaîne pour une URL
    },
    // updateContentStyle() {
    //   if (this.maxImageWidth) {
    //     var style = document.createElement("style");
    //     // padding:1vw;
    //     this.contentStyleData = `
    //       .contentClass img {
    //         scroll-behavior: smooth;
    //       }

    //       @media only screen and (max-width: ${this.maxImageWidth + 400}px) {
    //         .contentClass img {
    //           float:none !important;
    //         }
    //       }
    //     `;

    //     style.innerHTML = this.contentStyleData;
    //     document.head.appendChild(style);
    //   }
    // },
    downloadAsWord() {
      let content = `
      <html>
        <head>
          <meta charset="UTF-8">
        </head>
        <body>
          ${this.content}
        </body>
      </html>
    `;
      let blob = htmlDocx.asBlob(content);
      let url = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = "article.docx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    chooseImage() {
      this.$refs.file_upload.click();
    },
    formateDate(date, format) {
      return moment(date).format(format);
    },
  },
  components: {
    BasicHelpBox,
    EditorContent,
    lighthouse,
  },
  // beforeUnmount() {
  //   this.editor.destroy()
  // },
};
</script>

<style lang="scss">
// .ProseMirror-selectednode img{
//   height: 100% !important;
// }

.ProseMirror-selectednode div div {
  background-color: lightgrey !important;
  border: solid 1px var(--C1) !important;
}

.tiptap.ProseMirror {
  padding: 16px;
  border: solid 1px var(--C1);
}

.tiptap {
  :first-child {
    margin-top: 0;
  }

  ul,
  ol {
    padding: 0 1rem;
    margin: 1.25rem 1rem 1.25rem 0.4rem;

    li {
      margin-left: 10px !important;
    }

    li p {
      margin-top: 0.25em;
      margin-bottom: 0.25em;
    }
  }
}
</style>
